import { Container, Nav, Navbar } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import styles from './Header.module.css';

export default function Header() {
    const navigate = useNavigate();

    return (
        <>
            <Navbar sticky='top'>
                <Container fluid>
                    <Nav className="me-auto">
                        <Nav.Link onClick={() => navigate('/')}>Home</Nav.Link>
                        <Nav.Link onClick={() => navigate('/json')}>JSON</Nav.Link>
                        <Nav.Link onClick={() => navigate('/xml')}>XML</Nav.Link>
                        <Nav.Link onClick={() => navigate('/yaml')}>YAML</Nav.Link>
                        <Nav.Link onClick={() => navigate('/url')}>URL</Nav.Link>
                        <Nav.Link onClick={() => navigate('/html')}>HTML</Nav.Link>
                        <Nav.Link onClick={() => navigate('/base64')}>Base64</Nav.Link>
                        <Nav.Link onClick={() => navigate('/jwt')}>JWT</Nav.Link>
                        <Nav.Link onClick={() => navigate('/markdown')}>Markdown</Nav.Link>
                    </Nav>
                </Container>
            </Navbar>
            <div className={styles.header}/>
        </>
    );
}